// import type { AssetResultMatch } from '@frameio/graphql-client/generated';
import type { AssetResultMatch } from '../types';

type MatchTypes = NonNullable<AssetResultMatch['__typename']>;

const EXCLUDED_MATCH_FIELD_TYPES: MatchTypes[] = ['NameMatch'];
/**
 * @todo (SRCH-611): Add remaining MatchTypes when available in the API
 */
const PREFFER_MATCH_TYPE_ORDER = [
  'TranscriptionMatch',
  'VisualMatch',
  'CommentMatch',
  'StatusMatch',
  'KeywordsMatch',
  'AssigneeMatch',
  'CreatorMatch',
  'FormatMatch',
  'SourceFilenameMatch',
  'RatingMatch',
  'CommentCountMatch',
  'PageCountMatch',
  'DurationMatch',
  'FilesizeMatch',
  'AudioSampleRateMatch',
];

export const getSortedMatchesSubset = (
  matches: AssetResultMatch[],
  excludedTypes: MatchTypes[] = EXCLUDED_MATCH_FIELD_TYPES
) => {
  const matchesSubset = matches?.filter(
    (match) =>
      match && match.__typename && !excludedTypes.includes(match.__typename)
  );

  return matchesSubset?.sort((a, b) => {
    return (
      PREFFER_MATCH_TYPE_ORDER.indexOf(a?.__typename ?? '') -
      PREFFER_MATCH_TYPE_ORDER.indexOf(b?.__typename ?? '')
    );
  });
};
